// extracted by mini-css-extract-plugin
export default {"root":"chats___root___cbc8335f"};